import { Text } from '@mantine/core';
import { AddRemoveItemList } from './AddRemoveItemList';
import { PickerValue } from '../fields/types';

interface PickerOptionsConfigProps {
  items: PickerValue[];
  inputValue: string;
  inputLabel: string;
  onInputChange: (value: string) => void;
  onAddItem: () => void;
  onRemoveItem: (index: number) => void;
  addButtonDisabled?: boolean;
}

export const PickerOptionsConfig = ({
  items,
  inputValue,
  inputLabel,
  onInputChange,
  onAddItem,
  onRemoveItem,
  addButtonDisabled = false,
}: PickerOptionsConfigProps) => {
  return (
    <AddRemoveItemList
      items={items}
      inputLabel={inputLabel}
      inputValue={inputValue}
      onInputChange={onInputChange}
      onAddItem={onAddItem}
      onRemoveItem={onRemoveItem}
      renderItem={(item) => <Text>{item.label}</Text>}
      addButtonDisabled={addButtonDisabled}
    />
  );
};
